import { getFieldsetData } from '../managers/FieldsetManager/fieldsetData';
export function appendFieldsFrom(obj, prefix, form) {
  for (var key in obj) {
    if (!obj.hasOwnProperty(key)) continue;
    var name = prefix ? prefix + "[" + key + "]" : key;
    var val = obj[key];
    if (Array.isArray(val) || typeof val === "object") {
      appendFieldsFrom(val, name, form);
    } else {
      var i = document.createElement("input");
      i.type = "hidden";
      i.name = name;
      i.value = val;
      form.appendChild(i);
    }
  }
}

export function findDifferences(obj1, obj2, onlyDiff = false) {
  let result = {};

  // Функция для рекурсивного сравнения двух объектов
  function recurse(currentKey, val1, val2) {
    // Оба значения являются объектами, сравниваем глубже
    if (typeof val1 === 'object' && typeof val2 === 'object' && val1 != null && val2 != null) {
      const objDiff = findDifferences(val1, val2, onlyDiff);
      if (Object.keys(objDiff).length > 0) {
        result[currentKey] = objDiff; // Сохраняем только те ключи, где есть различия
      }
    } else if (val1 !== val2) {
      // Примитивные типы или значения отличаются
      if (!onlyDiff) result[currentKey] = { oldValue: val1, newValue: val2 };
      else result[currentKey] = val2;
    }
  }

  // Перебор ключей первого объекта
  for (let key in obj1) {
    if (obj1.hasOwnProperty(key)) {
      recurse(key, obj1[key], obj2[key]);
    }
  }

  // Перебор ключей второго объекта, которые могли быть пропущены в первом объекте
  for (let key in obj2) {
    if (obj1)
      if (obj2.hasOwnProperty(key) && !obj1.hasOwnProperty(key)) {
        recurse(key, obj1[key], obj2[key]);
      }
  }

  return result;
}

export function containsCyrillic(str) {
  return /[а-яёА-ЯЁ]/.test(str);
}

export function getDataForm(element, addAdditionalData = true) {
  const fieldsetForm = element.closest('form').querySelector('fieldset');

  return getDataAll(fieldsetForm, addAdditionalData);
}

export function getDataAll(element, addAdditionalData = true) {
  // @ts-expect-error
  if (element instanceof jQuery) {
    element = element[0];
  }
  if (!element || (typeof element === 'object' && !element.tagName && Object.keys(element).length === 0)) {
    return {};
  }
  // console.log(element);
  const closestElement = element.dataset?.all || element.tagName === 'FIELDSET' ? element : (element?.closest('[data-all], FIELDSET') ?? element.querySelector('FIELDSET'));
  const dataAll = closestElement ? (closestElement.tagName === 'FIELDSET' ? closestElement.data : JSON.parse(closestElement.dataset?.all || '{}')) : {};

  // Получаем дополнительные данные из того же элемента, если они есть
  const additionalData = closestElement && addAdditionalData ? JSON.parse(closestElement.dataset.additionalData || '{}') : {};

  // Объединяем основные данные и дополнительные данные в один объект
  return Object.assign({}, additionalData, dataAll);
}

export async function getDataAllAsync(element, addAdditionalData = true) {
  // @ts-expect-error
  if (element instanceof jQuery) {
    element = element[0];
  }
  if (!element || (typeof element === 'object' && !element.tagName && Object.keys(element).length === 0)) {
    return {};
  }
  
  const closestElement = element.dataset?.all || element.tagName === 'FIELDSET' ? element : (element?.closest('[data-all], FIELDSET') ?? element.querySelector('FIELDSET'));
  const dataAll = closestElement ? (closestElement.tagName === 'FIELDSET' ? closestElement.data : JSON.parse(closestElement.dataset?.all || '{}')) : {};
  const additionalData = closestElement && addAdditionalData ? JSON.parse(closestElement.dataset.additionalData || '{}') : {};
  
  return Object.assign({}, additionalData, dataAll);
}

export function formatDateToRF(dateString) {
  const date = new Date(dateString);
  return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
}